"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectUtil = void 0;
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var get_1 = __importDefault(require("lodash/get"));
var set_1 = __importDefault(require("lodash/set"));
// @ts-ignore
var json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
var ObjectUtil = /** @class */ (function () {
    function ObjectUtil() {
    }
    ObjectUtil.exists = function (object) {
        return typeof object !== 'undefined';
    };
    ObjectUtil.get = function (object, path) {
        return get_1.default(object, path);
    };
    ObjectUtil.set = function (object, path, value) {
        return set_1.default(object, path, value);
    };
    ObjectUtil.removeKeysWithUndefined = function (object) {
        var cloned = Object.assign({}, object);
        var removedKeys = [];
        Object.keys(object).forEach(function (key) {
            if (cloned[key] === undefined) {
                removedKeys.push(key);
            }
        });
        removedKeys.forEach(function (removedKey) {
            delete cloned[removedKey];
        });
        return cloned;
    };
    ObjectUtil.clone = function (o) {
        return cloneDeep_1.default(o);
    };
    ObjectUtil.isStrictEqual = function (o1, o2) {
        return json_stable_stringify_1.default(o1) === json_stable_stringify_1.default(o2);
    };
    return ObjectUtil;
}());
exports.ObjectUtil = ObjectUtil;
exports.default = ObjectUtil;
//# sourceMappingURL=ObjectUtil.js.map